import { UseMutationResult } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useAppNotification } from '@feature/utils';

interface UseDeleteReturn {
  onDelete: () => Promise<unknown>;
  isDeleting: boolean;
}

interface UseDeleteOptions {
  mutation: UseMutationResult<unknown, Error, void>;
  navigateTo: {
    to: string;
  } | null;
}

export function useDelete(options: UseDeleteOptions): UseDeleteReturn {
  const { mutation, navigateTo } = options;

  const navigate = useNavigate();
  const notification = useAppNotification();
  const onDelete = useCallback(() => {
    return mutation.mutateAsync(undefined, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();

        if (navigateTo) {
          return navigate({ to: navigateTo.to });
        }
      },
    });
  }, [mutation, notification, navigate, navigateTo]);

  return {
    isDeleting: mutation.isPending,
    onDelete,
  };
}
